import { render, staticRenderFns } from "./addorginstaff.vue?vue&type=template&id=ff9da868&scoped=true&"
import script from "./addorginstaff.vue?vue&type=script&lang=js&"
export * from "./addorginstaff.vue?vue&type=script&lang=js&"
import style0 from "./addorginstaff.vue?vue&type=style&index=0&id=ff9da868&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9da868",
  null
  
)

export default component.exports